import SaversTypes from './SaversTypes';

export const setTrailerRequestId = (payload) => ({
  type: SaversTypes.SET_SELECTED_TRAILER_REQUEST,
  payload,
});

export const setLocationRequestId = (payload) => ({
  type: SaversTypes.SET_SELECTED_LOCATION_REQUEST,
  payload,
});

export const setSaversActiveTab = (payload) => {
  return { type: SaversTypes.SET_SAVERS_ACTIVE_TAB, payload };
};

export const setTrailerId = (payload) => ({
  type: SaversTypes.SET_SELECTED_TRAILER_ID,
  payload,
});

export const setRateList = (payload) => ({
  type: SaversTypes.SET_RATE_LIST,
  payload,
});

export const setSelectedRate = (payload) => ({
  type: SaversTypes.SET_SELECTED_RATE,
  payload,
});

export const setSelectedRateResult = (payload) => ({
  type: SaversTypes.SET_SELECTED_RATE_RESULT,
  payload,
});

export const setSelectedRateResultIndex = (payload) => ({
  type: SaversTypes.SET_SELECTED_RATE_RESULT_INDEX,
  payload,
});

export const setSelectedRateResultCarrier = (payload) => ({
  type: SaversTypes.SET_SELECTED_RATE_RESULT_CARRIER,
  payload,
});

export const setLoggedInUserType = (payload) => ({
  type: SaversTypes.SET_LOGGEDIN_USERTYPE,
  payload,
});

export const setSaversSuppliers = (payload) => ({
  type: SaversTypes.SET_SAVERS_SUPPLIER,
  payload,
});

export const setShipmentList = (payload) => {
  return { type: SaversTypes.SET_SHIPMENT_LIST, payload };
};

export const setShipmentFilters = (payload) => {
  return { type: SaversTypes.SET_SHIPMENT_FILTERS, payload };
};

export const getShipmentListInProgress = (payload) => {
  return { type: SaversTypes.GET_SHIPMENT_LIST_PROGRESS, payload };
};

export const getShipmentListInSuccess = (payload) => {
  return { type: SaversTypes.GET_SHIPMENT_LIST_SUCCESS, payload };
};

export const getShipmentListInError = (payload) => {
  return { type: SaversTypes.GET_SHIPMENT_LIST_ERROR, payload };
};
